// https://github.com/dequelabs/axe-core/blob/master/doc/API.md#api-name-axeconfigure
const axeConfig = {
    rules: [
        {
            id: 'heading-order',
            enabled: false,
        },
        {
            id: 'page-has-heading-one',
            enabled: false,
        },
    ],
};

export default axeConfig;